import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ActiveContractByCategory, ContractCategory, EffectiveUnitPrice } from '../types';
import { contractsService } from './services';

export const fetchActiveContractByCategory = createAsyncThunk<
  ActiveContractByCategory,
  ContractCategory,
  { rejectValue: string }
>('contracts/fetchActiveByCategory', async (category, { rejectWithValue }) => {
  try {
    return await contractsService.fetchActiveByCategory(category);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const fetchEffectiveUnitPrice = createAsyncThunk<
  EffectiveUnitPrice,
  ContractCategory,
  { rejectValue: string }
>('contracts/fetchEffectiveUnitPrice', async (category, { rejectWithValue }) => {
  try {
    return await contractsService.fetchEffectiveUnitPrice(category);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});
